{
  "tabs": {
    "users": "Usuários",
    "pics": "PICs",
    "lotNames": "Descrições de Lotes"
  },
  "users": {
    "userList": "Lista de Usuários",
    "email": "E-mail",
    "name": "Nome",
    "assignments": "Atribuições",
    "createdAt": "Criado em",
    "pics": "PICs",
    "farmerNames": "Nomes de Produtores",
    "invite": "Convidar",
    "edit": "Editar",
    "updateAssignments": "Atualizar Atribuições",
    "assignPics": "Atribuir PICs",
    "assignFarmerNames": "Atribuir Nomes de Produtores",
    "delete": "Excluir",
    "inviteNewUser": "Convidar novo usuário",
    "emailUsername": "E-mail (Este será o nome de usuário)",
    "firstName": "Nome",
    "lastName": "Sobrenome",
    "role": "Função",
    "businessName": "Nome da Empresa",
    "assignLotsToPics": "Atribuir Lotes aos PICs",
    "lotsHelperText": "Por favor, separe múltiplos lotes com vírgula. Digite apenas a palavra \"All\" se preferir atribuir todos os lotes de um PIC.",
    "submit": "Enviar",
    "cancel": "Cancelar",
    "notAllowedAdmin": "Este usuário não tem permissão para ser administrador",
    "updateUser": "Atualizar {{displayName}}",
    "confirmDelete": "Confirmar exclusão de {{displayName}}",
    "confirmDeleteMessage": "Tem certeza que deseja excluir {{displayName}}?",
    "activeBookingsWarning_one": "{{displayName}} ainda possui {{count}} agendamento ativo. Exclua ou reatribua os agendamentos primeiro.",
    "activeBookingsWarning_other": "{{displayName}} ainda possui {{count}} agendamentos ativos. Exclua ou reatribua os agendamentos primeiro.",
    "updateAssignmentsOf": "Atualizar Atribuições de {{displayName}}",
    "assignPicsTo": "Atribuir PICs a {{displayName}}",
    "assignFarmerNamesTo": "Atribuir Nomes de Produtores a {{displayName}}",
    "assignment": {
      "location": "Local",
      "locationPlaceholder": "Escolha um local",
      "noLocations": "Nenhum local em que você possa atribuir",
      "capability": "Capacidade",
      "capabilities": {
        "user": "Usuário",
        "admin": "Admin"
      },
      "persona": "Persona",
      "personaPlaceholder": "Sem persona",
      "forbidden": "Você só pode alterar pessoas com atribuição em um local que você administra."
    },
    "resendInvite": {
      "action": "Reenviar convite",
      "sent": "Convite enviado",
      "failed": "Não foi possível enviar o convite. Tente novamente.",
      "refused": {
        "signed_in": "Este usuário já entrou no sistema, então não há convite para reenviar.",
        "already_member": "Este usuário já é membro da organização.",
        "inactive": "Este usuário está desativado. Ative-o antes de reenviar o convite.",
        "no_workos_user": "Este usuário ainda não tem uma conta de acesso, então não há convite para reenviar.",
        "no_org": "Esta organização não está configurada para convites de acesso.",
        "not_found": "Não foi possível encontrar este usuário."
      }
    }
  },
  "lotNames": {
    "title": "Descrições de Lotes",
    "lotReference": "Lote",
    "killDate": "Data de Abate",
    "name": "Descrição",
    "updatedAt": "Atualizado em",
    "add": "Adicionar",
    "edit": "Editar",
    "delete": "Excluir",
    "editName": "Editar Descrição do Lote",
    "selectLot": "Selecione um Lote",
    "update": "Atualizar",
    "reset": "Redefinir",
    "cancel": "Cancelar"
  }
}
